import { PROJECT_VARIANTS } from '../../constants';
import * as resonanceActions from '../../redux/resonance/resonanceActions';
import * as consumerResonanceActions from '../../redux/consumer/resonance/consumerResonanceActions';

const resonanceActionsMapping = {
  getSingleMessageCorrelations: {
    [PROJECT_VARIANTS.ADMIN]: resonanceActions.getSingleMessageCorrelations,
    [PROJECT_VARIANTS.CONSUMER]: consumerResonanceActions.getConsumerSingleMessageCorrelations,
  },
  getFilteredMessages: {
    [PROJECT_VARIANTS.ADMIN]: resonanceActions.getFilteredMessages,
    [PROJECT_VARIANTS.CONSUMER]: consumerResonanceActions.getConsumerFilteredMessages,
  },
  getResonanceConcepts: {
    [PROJECT_VARIANTS.ADMIN]: resonanceActions.getResonanceConcepts,
    [PROJECT_VARIANTS.CONSUMER]: consumerResonanceActions.getConsumerResonanceConcepts,
  },
  getResonanceH2HConcepts: {
    [PROJECT_VARIANTS.ADMIN]: resonanceActions.getResonanceH2HConcepts,
    [PROJECT_VARIANTS.CONSUMER]: consumerResonanceActions.getConsumerResonanceH2HConcepts,
  },
  getResonanceBackgroundData: {
    [PROJECT_VARIANTS.ADMIN]: resonanceActions.getResonanceBackgroundData,
  },
};

export default resonanceActionsMapping;
